import React from 'react';
import styled from 'styled-components';

const RnRHeader = () => (
  <RnRHeaderWrapDiv>
    <RnRHeaderLeftWrapDiv>
      <RnRHeaderLoaderWrapDiv></RnRHeaderLoaderWrapDiv>
    </RnRHeaderLeftWrapDiv>
    <RnRHeaderLeftWrapDiv> </RnRHeaderLeftWrapDiv>
  </RnRHeaderWrapDiv>
);

export default RnRHeader;

const RnRHeaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  padding:${props.theme.spacing.large};
  border-bottom: ${props.theme.misc.border.base} solid ${props.theme.colors.ash.medium};
  width:100%;
  justify-content: space-between;


`,
);

const RnRHeaderLeftWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  width:50%;

`,
);

const RnRHeaderLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:41.8rem;
  height:2.5rem;

`,
);
